import { FETCH_VISIBLE_OVERVIEW__SUCCESS } from "../../actionTypes";
import { TemplateMetadataByIdSTORE, TemplatesActions } from "../../types";

const initialState: TemplateMetadataByIdSTORE = {};

const byId = (
  state = initialState,
  action: TemplatesActions
): TemplateMetadataByIdSTORE => {
  switch (action.type) {
    case FETCH_VISIBLE_OVERVIEW__SUCCESS: {
      // tenhle lint problem zmizí s ts immer
      const visibleTemplatesMetadata = action.payload;
      const oldById = state;
      const newById: TemplateMetadataByIdSTORE = {};

      Object.keys(oldById)
        .map(Number)
        .forEach((id) => {
          const template = oldById[id];
          const exists = template !== undefined && template !== undefined;
          if (!exists) return;

          newById[id] = oldById[id];
        });

      visibleTemplatesMetadata.forEach((templateMetadata) => {
        const { id } = templateMetadata;
        const newMetadata = {
          ...templateMetadata,
          isFetching: false,
        };

        newById[id] = newMetadata;
      });

      return newById;
    }
    default:
      return state;
  }
};

export default byId;
